import React from "react";
import { PromoValidateResult } from "../../../utils/api/apartmentRentalsAPI";

interface Props {
  promoInput: string;
  setPromoInput: (v: string) => void;
  promoResult: PromoValidateResult | null;
  promoLoading: boolean;
  onValidate: () => void;
  onClear: () => void;
  currency?: string;
  placeholder?: string;
  applyLabel?: string;
}

const PromoBlock: React.FC<Props> = ({
  promoInput, setPromoInput, promoResult, promoLoading, onValidate, onClear, currency,
  placeholder = "Promo kod", applyLabel = "Primijeni",
}) => {
  const fmtAmt = (n: number) => {
    if (currency === "EUR") return `€${Math.round(n)}`;
    if (currency === "BAM") return `${Math.round(n)} KM`;
    return `${new Intl.NumberFormat("sr-RS").format(Math.round(n))} RSD`;
  };

  return (
    <div className="pab-promo-block">
      {promoResult?.valid ? (
        <div className="pab-promo-block__applied">
          <span>
            🎉 <strong>{promoInput.toUpperCase()}</strong> — uštedite {fmtAmt(promoResult.discount!)}
            {promoResult.description && <span className="pab-promo-block__desc"> ({promoResult.description})</span>}
          </span>
          <button type="button" onClick={onClear} className="pab-promo-block__clear" aria-label="Ukloni promo kod">✕</button>
        </div>
      ) : (
        <div>
          <div className="pab-promo-block__row">
            <input
              type="text"
              className="pab-input"
              placeholder={placeholder}
              value={promoInput}
              onChange={(e) => setPromoInput(e.target.value.toUpperCase())}
              onKeyDown={(e) => e.key === "Enter" && onValidate()}
              style={{ textTransform: "uppercase" }}
            />
            <button
              type="button"
              className="pab-promo-block__apply"
              onClick={onValidate}
              disabled={!promoInput.trim() || promoLoading}
            >
              {promoLoading ? "…" : applyLabel}
            </button>
          </div>
          {promoResult?.valid === false && promoResult.message && (
            <div className="pab-field-error">✕ {promoResult.message}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default PromoBlock;
